import { Theme } from "@mui/material/styles";

export default function Paper(theme: Theme) {
  return {
    MuiPaper: {
      styleOverrides: {
        root: ({ theme }: any) => ({
          boxShadow:
            "0px 3px 1px -2px rgba(35, 39, 44, 0.2), 0px 2px 2px rgba(35, 39, 44, 0.14), 0px 1px 5px rgba(35, 39, 44, 0.12)",
          borderRadius: "10px",
          background: "rgb(255, 255, 255)",
        }),
      },
    },
  };
}
